<template>
  <div class="visitor-list-page">
    <vue-headful title="Посетители" />
    <div class="container">
      <div class="visitor-block">
        <div class="profile-content">
          <div class="row">
            <div class="col-md-8">
              <h2>Посетители</h2>
            </div>
          </div>

          <hr>

          <div class="row filters-block">
            <div class="col-md-5">
              <div class="row">
                <div class="input-group">
                  <input
                    v-model="search"
                    ref="searchBar"
                    type="text"
                    class="form-control"
                    placeholder="Поиск по посетителям"
                    @change="changeSearch($event)"
                  >
                  <div class="input-group-btn">
                    <button
                      type="button"
                      class="btn btn-default"
                      @click="sendSearch()"
                    >
                      <span class="glyphicon glyphicon-search"></span>
                    </button>
                    <dropdown ref="dropdown">
                      <btn type="" class="dropdown-toggle btn btn-default">
                        <span class="glyphicon glyphicon-filter"></span>
                      </btn>
                      <template v-slot:dropdown>
                        <li v-for="(label, column) in filterColumnsData"
                          :key="label"
                          :value="column"
                          @click="handleFilter(column)"
                        >
                          <a role="button">{{ label }}</a>
                        </li>
                      </template>
                    </dropdown>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="active-filter">
                  <small>
                    <span class="glyphicon glyphicon-filter"></span>
                    &nbsp;
                    <b id="active-filter">{{ columnsFilterParams }}</b>
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div v-if="visitors && visitors.length" class="row">
            <div class="col-md-12 visitor-list">
              <visitor-item
                v-for="(visitor, key) in visitors"
                :key="key"
                :visitor=visitor
                :visitor-key="Number(key)"
                :pagination="pagination"
                :user="user"
                :statuses="statuses"
                :applicationMenuConfiguration="applicationMenuConfiguration"
              />
              <infinite-loading
                  v-if="visibleInfiniteLoading"
                  :identifier="infiniteId"
                  @infinite="infiniteLoadVisitors"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApplicationClient from '../../helpers/api-client/Application'
import VisitorClient from '../../helpers/api-client/Visitor'
import VisitorItem from './VisitorItem.vue'
import { ApiClient } from '../../helpers/api-client/ApiClient'

export default {
  name: 'VisitorList',

  components: { VisitorItem },

  data: function () {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      canFocusToSearchBar: true,
      canInfinite: true,
      filterColumns: 'all',
      filterColumnsData: {
        all: 'Все поля'
      },
      pagination: {
        per: 10,
        active: 1,
        count: 0
      },
      preloader: true,
      search: '',
      infiniteId: 0,
      visitors: [],
      statuses: {
        type: Object
      },
      applicationMenuConfiguration: {
        type: Object
      }
    }
  },

  computed: {
    columnsFilterParams() {
      return this.filterColumnsData[this.filterColumns] ?? this.filterColumnsData.all
    },

    filterParams() {
      const search = this.search;
      const filterColumns = this.filterColumns;
      const page = this.pagination.active;

      return {
        search,
        filterColumns,
        page
      };
    },

    visibleInfiniteLoading() {
      return this.pagination.active < this.countPages() && this.pagination.active > 0
    }
  },

  async created() {
    const vue = this;

    this.pagination.active = history.state?.page ?? 1;

    await this.fetchData()
    await this.handleCurrentPage(this.$route.query)

    this.hidePreloader()

    window.addEventListener('popstate', (event) => {
      if (event.state) {
        vue.fillSearchParamsFromState(event);
        vue.sendSearch();
      }
    });
  },

  methods: {
    changeSearch(event) {
      this.search = event.target.value
      this.insertSearchParams()
      this.sendSearch()
    },

    countPages() {
      return Math.ceil(this.pagination.count / this.pagination.per)
    },

    async fetchCfgMenuApplication() {
      await ApiClient.cfgMenuDataApplicationMenu({
        type: 'application'
      }).then((response) => {
        this.applicationMenuConfiguration = response.data.data
      })
    },

    async fetchData() {
      this.statuses = await ApplicationClient.statuses().then(response => response.data)
      await this.fetchCfgMenuApplication()
      const data = await VisitorClient.extraData().then(response => response.data)
      this.setExtraData(data)
    },

    fillSearchParamsFromState({ search, filterColumns, page }) {
      this.search = search ?? ''
      this.filterColumns = filterColumns ?? 'all'
      this.pagination.active = page ?? 1
    },

    firstPage() {
      this.pagination.active = 1
      this.replaceStatePageData()
    },

    async getPageVisitors(activePage, perPage = null) {
      let results = []

      await VisitorClient.getList({
        page: activePage,
        perPage: perPage || this.pagination.per,
        searchQuery: this.search,
        filterColumns: this.filterColumns
      }).then((response) => {
        this.pagination.count = response?.data?.data?.count
        results = response?.data?.data?.models
      })

      return results
    },

    async handleCurrentPage(query) {
      this.fillSearchParamsFromState(query)

      if (this.pagination.active > 1 && this.visitors.length <= this.pagination.per) {
        this.canFocusToSearchBar = false
        this.canInfinite = false

        const needleCount = this.pagination.active * this.pagination.per
        this.visitors = await this.getPageVisitors(1, needleCount)
      } else {
        this.visitors = await this.getPageVisitors(this.pagination.active)
      }
    },

    handleFilter(value) {
      const columnLabel = this.filterColumnsData[value] ?? 'Все поля'
      const filter = document.getElementById('active-filter')
      filter.textContent = columnLabel
      this.filterColumns = value
      this.insertSearchParams()
    },

    infiniteLoadVisitors($state) {
      const _this = this

      setTimeout(async function () {
        if (_this.pagination.active < _this.countPages() && _this.pagination.active > 0) {
          if (!_this.canInfinite) {
            $state.loaded()
            _this.canInfinite = true

            return
          }

          _this.pagination.active++

          const visitors = await _this.getPageVisitors(_this.pagination.active)
          if (visitors.length) {
            _this.visitors.push(...visitors)
            $state.loaded()
          } else {
            $state.complete()
          }

          _this.replaceStatePageData()
        }
      }, 100)
    },

    async insertSearchParams() {
      this.firstPage()
      await this.$router.push({ query: { ...this.filterParams } })
    },

    replaceStatePageData() {
      const params = history.state ?? this.filterParams
      params.page = this.pagination.active

      const url = new URL(window.location)
      url.searchParams.set('page', this.pagination.active)
      history.replaceState(params, undefined, url.href)
    },

    async sendSearch() {
      this.firstPage()
      this.infiniteId += 1

      this.visitors = await this.getPageVisitors(this.pagination.active)
    },

    setExtraData(data) {
      this.filterColumnsData = { ...this.filterColumnsData, ...data.filterColumns }
    }
  }
}
</script>
